export default {
  blank: () => import("/root/injective/injective-dmm-v2/layouts/blank.vue"),
  default: () => import("/root/injective/injective-dmm-v2/layouts/default.vue"),
  landing: () => import("/root/injective/injective-dmm-v2/layouts/landing.vue")
}